import makeStyles from '@material-ui/core/styles/makeStyles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  root: {
    padding: '38px 53px',
  },
  title: {
    color: '#333',
    marginBottom: 10,
  },
  bannerContainer: {
    borderRadius: 10,
    width: '80%',
    height: 123,
    backgroundColor: theme.palette.grey['200'],
    overflow: 'hidden',
  },
  banner: {
    objectFit: 'cover',
    backgroundColor: theme.palette.grey['200'],
    width: '100%',
    height: '100%',
  },
  giftCardContainer: {
    borderRadius: 20,
    backgroundColor: theme.palette.grey['200'],
    width: 205,
    height: 134,
    overflow: 'hidden',
  },
  bottomButton: {
    whiteSpace: 'nowrap',
    margin: ({ direction }: LayoutDirection) => (direction === 'rtl' ? '0 10px 5px 0' : '0 0 0 10px'),
    width: 'auto',
    minWidth: 75,
  },
  makeDefaultButton: {
    width: 135,
    backgroundColor: theme.palette.secondary.main,
  },
}));
